import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { APP_TITLE, LOGOUT_BUTTON } from "../../constants/labels";
import { userSignOut } from "./../../redux/actions/authActions";
import { getLessons } from "./../../redux/actions/lessonsActions";

import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import StyledButton from "./StyledButton";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Hidden from "@material-ui/core/Hidden";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

import SideBar from "./SideBar";

const drawerWidth = 240;
const breakpoints = createBreakpoints({});

function pxToRem(value) {
  return `${value / 16}rem`;
}
const styles = (theme) => ({
  root: {
    display: "flex",
    "&$selected": {
      backgroundColor: "red"
    }
  },
  toolbar: {
    backgroundColor: "#0754a0", //#0754a0  #31444D
    paddingRight: 20, // keep right padding when drawer closed
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0
    }
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    [theme.breakpoints.down("md")]: {
      padding: "0 4px"
    },
    ...theme.mixins.toolbar
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: "1%",
    marginRight: "1%",
    [breakpoints.up("md")]: {
      marginRight: "2%"
    }
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1,
    fontSize: pxToRem(18),
    [breakpoints.down("md")]: {
      fontSize: pxToRem(18)
    },
    [breakpoints.down("sm")]: {
      fontSize: pxToRem(16)
    },
    [breakpoints.down("xs")]: {
      fontSize: pxToRem(14)
    }
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    [theme.breakpoints.down("sm")]: {
      position: "absolute"
    }
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 0
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing.unit * 2
    },
    padding: theme.spacing.unit * 3,
    height: "100vh",
    overflow: "auto"
  },
  chartContainer: {
    marginLeft: -22
  },
  tableContainer: {
    height: 320
  },
  button: {
    [breakpoints.down("md")]: {
      margin: "1%"
    },
    margin: theme.spacing.unit,
    justifyContent: "flex-end",
    fontSize: pxToRem(16),
    [breakpoints.down("md")]: {
      fontSize: pxToRem(14)
    },
    [breakpoints.down("sm")]: {
      fontSize: pxToRem(12)
    },
    [breakpoints.down("xs")]: {
      fontSize: pxToRem(10)
    }
  },
  listSubHeader: {
    margin: "8px 0"
  },
  htmlTooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 240,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    "& b": {
      fontWeight: theme.typography.fontWeightMedium
    }
  },
  selected: {
    backgroundColor: "#31444D !important",
    "& h3": {
      color: "white"
    },
    "& svg": {
      color: "white"
    }
  },
  a: {
    color: "white",
    textDecoration: "none"
  }
});

class Dashboard extends Component {
  state = {
    open: true
  };

  toggle = () => {
    // const { showSidebar, actions } = this.props;
    // actions.setSidebar({ state: !showSidebar });
    this.setState((state) => ({ open: !state.open }));
  };

  sideBarOpen = () => {
    this.setState((state) => ({ open: true }));
  };

  sideBarClose = () => {
    this.setState((state) => ({ open: false }));
  };

  componentDidMount() {
    this.props.actions.getLessons();
    if (window.innerWidth < 700) {
      setTimeout(this.sideBarOpen, 8000);
      setTimeout(this.sideBarClose, 1000);
    }
  }

  render() {
    const {
      classes,
      location: { pathname }
    } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <Header
            classes={classes}
            toggle={this.toggle}
            userSignOut={this.props.actions.userSignOut}
          />
          <Hidden mdUp>
            <SideBar
              classes={classes}
              isOpen={!this.state.open}
              lessons={this.props.lessons}
            />
          </Hidden>
          <Hidden smDown>
            <SideBar
              classes={classes}
              isOpen={this.state.open}
              lessons={this.props.lessons}
              pathname={pathname}
            />
          </Hidden>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            {this.props.children}
          </main>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  lessons: state.lessons
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ userSignOut, getLessons }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Dashboard));

const Header = ({ classes, toggle, userSignOut }) => {
  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar disableGutters={true} className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={toggle}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="body1"
          color="inherit"
          noWrap
          className={classes.title}
        >
          {APP_TITLE}
        </Typography>
        <StyledButton
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
        >
          <a
            className={classes.a}
            href="mailto:support@uttarainfo.com?cc=vikram.shastry@gmail.com&subject=Query from Java videosite"
          >
            Contact Support
          </a>
        </StyledButton>
        <StyledButton
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
          onClick={(event) => {
            event.preventDefault();
            userSignOut();
          }}
        >
          {LOGOUT_BUTTON}
        </StyledButton>
      </Toolbar>
    </AppBar>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Dashboard.js